import React from 'react';
import TournamentRows from "./TournamentRows";
import Iframe from 'react-iframe'
import TournamentCards from "./TournamentCards";
import { CardDeck } from 'reactstrap';
import AdChitika from "../Ads/AdChitika";

export default class TournamentGrid extends React.Component {
    constructor() {
        super();
        this.state = {
          upcoming: [],
          past: []
        };
    }

    componentDidMount() {
      fetch('https://us-central1-novablitzhq-api.cloudfunctions.net/challongeTournamentsGet')
      .then(function(response) {
        // The response is a Response instance.
        // You parse the data into a useable format using `.json()`
        return response.json();
      }).then(data => {
        var today = new Date();
        var upcomingTournaments = data.filter(function (tourney) {
           var tDate = new Date(tourney.tournament.start_at);
            return (tDate.getTime() > today.getTime());
        });

        var pastTournaments = data.filter(function (tourney) {
           var tDate = new Date(tourney.tournament.start_at);
            return (tDate.getTime() < today.getTime());
        });

        this.setState({
          upcoming:[upcomingTournaments],
          past: [pastTournaments]
        });
      });
    }


    render() {
      var deckSectionStyle = {
        marginTop:60,
        justifyContent: "center"
      }

      var deckStyle = {
        backgroundColor: "black",
        color: "white",
        marginTop: -2
      }

      var comingSoonStyle = {
         paddingTop: 30,
         paddingBottom: 30
      }

      var comingSoonStyle2 = {
         paddingTop: 10,
         paddingBottom: 10,
         marginTop: 10,

         backgroundColor: "black",
         borderStyle: "solid",
         borderColor: "darkslategray"
      }

      var h3Style = {
        fontFamily: "Audiowide, cursive",
        color: "cadetblue"
      }

      var dgrdecks = this.state.items;
        return(

          <div className="container">

          <div id="deck" className="d-flex flex-row flex-wrap" style={deckSectionStyle} >
          <AdChitika publisher="Gaztingo" />
          <div className="container">
            <div style={comingSoonStyle2} className="row justify-content-center rounded">
              <h3 style={h3Style}>Upcoming Tournaments</h3>
            </div>
          </div>
              <table id="tournaments" style={deckStyle} className="table table-sm">
                  <thead>
                      <tr>
                      <th>Tournament URL</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Start Date and Time</th>
                      <th>Check In Duration (min)<br/>Prior to Start Time</th>
                      <th>Participants</th>
                      </tr>
                  </thead>
                  <tbody>
                    <TournamentRows tRows={this.state.upcoming}/>
                  </tbody>
                  <tfoot>
                  </tfoot>
              </table>

              <CardDeck style={comingSoonStyle} id="comingSoon" className="d-flex justify-content-center" >
                  <TournamentCards />
              </CardDeck>

              <div className="container">
                <div style={comingSoonStyle2} className="row justify-content-center rounded">
                  <h3 style={h3Style}>Past Tournaments</h3>
                </div>
              </div>
              <table id="tournaments" style={deckStyle} className="table table-sm">
                  <thead>
                      <tr>
                      <th>Tournament URL</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Start Date and Time</th>
                      <th>Check In Duration (min)<br/>Prior to Start Time</th>
                      <th>Participants</th>
                      </tr>
                  </thead>
                  <tbody>
                    <TournamentRows tRows={this.state.past}/>
                  </tbody>
                  <tfoot>
                  </tfoot>
              </table>

          </div>
          </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/Tournaments/TournamentGrid.js